import styled, { css } from "styled-components";


export const ButtonWrapper = styled.button`
  background-color: transparent;
  border: none;
  height: 48px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border-radius: 5px;
  
  ${(props) => props.size === "md" && css`
    height: 44px;
  `}

  ${(props) => props.size === "sm" && css`
    height: 32px;
  `}

  ${(props) => props.variant === "primary" && css`
    color: #FFFFFF;
    background-color: #2555EF;
  `}

  ${(props) => props.variant === "filter" && css`
    color: #2555EF;
    border: 1px solid #2555EF;
  `}

  ${(props) => props.variant === "primary-outline" && css`
    color: #2555EF;
    border: 1px solid #2555EF;
  `}

  ${(props) => props.variant === "secondary-light" && css`
    color: #2555EF;
    background-color: #2555EF14;
  `}


  ${(props) => props.disabled && css`
    cursor: not-allowed;
    opacity: 0.5;
  `}
`